const localEnv = require("./local.env");
const pubEnv = require("./pub.env");
const prodEnv = require("./prod.env");

const NODE_ENV = process.env.NODE_ENV;
console.log(NODE_ENV);

if (NODE_ENV) {
  if (NODE_ENV === "development") {
    const Env = { ...pubEnv, ...localEnv };
    global.apiUrl = Env.BASE_API;
    global.apiImageUpload = Env.IMAGE_API;
  } else if (NODE_ENV === "testing") {
    global.apiUrl = pubEnv.BASE_API;
    global.apiImageUpload = pubEnv.IMAGE_API;
  } else if (NODE_ENV === "production") {
    global.apiUrl = prodEnv.BASE_API;
    global.apiImageUpload = prodEnv.IMAGE_API;
  } else {
    throw new Error("No matching config was found!");
  }
}
